/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpServiceId } from '@squiz/dxp-auth';
import { useObservable } from '@squiz/dxp-console-support';
import { useMemo } from 'react';
import { Observable } from 'rxjs';
import { EntityTenantSettings } from '../../Entities';
import { getTenantSettingsService } from '../../Utilities';
import { TenantDomainValue, useTenantSiteListResult } from './useTenantSiteList.defs';
import { useTenantSiteListProps } from './useTenantSiteList.props';

export const useTenantSiteList = ({ filteringFn }: useTenantSiteListProps = {}): useTenantSiteListResult => {
  const tenantSettingsService = getTenantSettingsService();

  const siteList$ = useMemo((): Observable<EntityTenantSettings<TenantDomainValue> | null> => {
    return tenantSettingsService.getSettingsList<TenantDomainValue>({
      schemaId: 'domain',
      serviceId: DxpServiceId.dxpConsole,
    });
  }, [tenantSettingsService]);

  const [siteList, error, state] = useObservable(siteList$, [tenantSettingsService], undefined, true);
  if (!siteList) {
    return [null, state, error];
  }

  if (filteringFn) {
    const filteredSites = siteList.data.filter(filteringFn);
    return [filteredSites, state, error];
  }

  return [siteList.data, state, error];
};
